import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import LtiRequestType from './types';

const Lti1p3Form = forwardRef(
  ({ loginUrl, targetUrl, clientId, iss, type, target, loginHint }, ref) => (
    <form
      ref={ref}
      method="post"
      action={loginUrl}
      target={target}
      data-testid="lti1p3-form"
    >
      <input type="hidden" name="iss" value={iss} />
      <input type="hidden" name="client_id" value={clientId} />
      <input type="hidden" name="target_link_uri" value={targetUrl} />
      <input type="hidden" name="login_hint" value={loginHint} />
      {type === LtiRequestType.DEEP_LINKING && (
        <input
          type="hidden"
          name="lti_message_hint"
          value="LtiDeepLinkingRequest"
        />
      )}
    </form>
  )
);

Lti1p3Form.propTypes = {
  loginUrl: PropTypes.string.isRequired,
  targetUrl: PropTypes.string.isRequired,
  clientId: PropTypes.string.isRequired,
  iss: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired, // Ensure LtiRequestType is a string
  target: PropTypes.string.isRequired,
  loginHint: PropTypes.string.isRequired,
};

export default Lti1p3Form;
